import { Card, CardContent, Grid } from "@mui/material"
import { styled } from "@mui/material/styles"
import { Link } from "react-router-dom"

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.grey[800],
  textDecoration: "none"
}))

export const StyledCard = styled(Card)({
  display: "flex",
  flexDirection: "column"
})

export const StyledDiv = styled("div")({
  display: "flex",
  flexDirection: "column"
})

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
  flex: "1 0 auto",
  [theme.breakpoints.up("md")]: {
    padding: "35px 45px"
  }
}))

export const StyledGrid = styled(Grid)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  [theme.breakpoints.between("sm", "md")]: {
    flexDirection: "column",
    alignItems: "flex-start"
  }
}))

export const StyledGreyGrid = styled(Grid)(({ theme }) => ({
  color: theme.palette.grey[600],
  fontSize: "0.875em",
  [theme.breakpoints.between("sm", "md")]: {
    alignItems: "flex-start"
  }
}))
